/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L2_NInputs */

const en_mk_sec_pg_l2_n = /** @type {(inputs: Mk_Sec_Pg_L2_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We store no passwords in production.`)
};

const id_mk_sec_pg_l2_n = /** @type {(inputs: Mk_Sec_Pg_L2_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada kata sandi yang kami simpan di produksi.`)
};

/**
* | output |
* | --- |
* | "We store no passwords in production." |
*
* @param {Mk_Sec_Pg_L2_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l2_n = /** @type {((inputs?: Mk_Sec_Pg_L2_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L2_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l2_n(inputs)
	return en_mk_sec_pg_l2_n(inputs)
});